<template>
    <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
    <div class="about">
        <section class="section page-wrapper">
            <figure class="section-image section-image--full-width demo">
                <img
                    src="~/assets/images/about-us-heading.webp"
                    :alt="$t('pages.about.heading_img_alt')"
                    class="section-image__image"
                />
            </figure>
            <div class="section__content">
                <h1 class="section__heading">
                    {{ $t('pages.about.heading') }}
                </h1>
                <p>
                    {{ $t('pages.about.intro_desc1') }}
                </p>
                <p>
                    {{ $t('pages.about.intro_desc2') }}
                </p>
                <p>
                    {{ $t('pages.about.intro_desc3') }}
                </p>
                <h2 class="section__subheading">{{ $t('pages.about.freedom_subheading') }}</h2>
                <p>
                    {{ $t('pages.about.freedom_desc') }}
                </p>
                <h2 class="section__subheading">{{ $t('pages.about.sharing_heading') }}</h2>
                <p>
                    {{ $t('pages.about.sharing_desc1') }}
                </p>
                <p>
                    {{ $t('pages.about.sharing_desc2') }}
                </p>
            </div>

            <div class="team">
                <h2 class="section__heading">{{ $t('pages.about.team_subheading') }}</h2>
                <div class="persons">
                    <div v-for="(person, index) in people" :key="index" class="person">
                        <img
                            v-lazy-load-image="require(`~/assets/images/people/${person.name.toLowerCase()}.webp`)"
                            :alt="person.name"
                            class="person__image"
                        />
                        <p class="person__name">{{ person.name }}</p>
                        <p class="person__title">{{ $t(person.key) }}</p>
                    </div>
                </div>
            </div>
            <Contact />
        </section>
    </div>
</template>

<script>
import Contact from '~/components/sections/Contact.vue';

export default {
    components: {
        Contact,
    },
    data() {
        return {
            people: [
                { name: 'Stefan', key: 'pages.about.stefan' },
                { name: 'Rickard', key: 'pages.about.rickard' },
                { name: 'Anders', key: 'pages.about.anders' },
                { name: 'Oliver', key: 'pages.about.oliver' },
                { name: 'Michele', key: 'pages.about.michele' },
                { name: 'Nicolas', key: 'pages.about.nicolas' },
                { name: 'Mirjam', key: 'pages.about.mirjam' },
                { name: 'Alina', key: 'pages.about.alina' },
                { name: 'Selina', key: 'pages.about.selina' },
                { name: 'Saphia', key: 'pages.about.saphia' },
                { name: 'Raphael', key: 'pages.about.raphael' },
                { name: 'Minna', key: 'pages.about.minna' },
                { name: 'Joshua', key: 'pages.about.joshua' },
                { name: 'Sebastian', key: 'pages.about.sebastian' },
                { name: 'Yasemin', key: 'pages.about.yasemin' },
                { name: 'Marco', key: 'pages.about.marco' },
                { name: 'Pi', key: 'pages.about.pi' },
                { name: 'Lorena', key: 'pages.about.lorena' },
                { name: 'Roie', key: 'pages.about.roie' },
                { name: 'Christine', key: 'pages.about.christine' },
                { name: 'Goran', key: 'pages.about.goran' },
                { name: 'Ante', key: 'pages.about.ante' },
                { name: 'Nenad', key: 'pages.about.nenad' },
                { name: 'Josip', key: 'pages.about.josip' },
                { name: 'Jelena', key: 'pages.about.jelena' },
                { name: 'Nezla', key: 'pages.about.nezla' },
            ],
        };
    },
    head() {
        return {
            title: this.$t('pages.about.heading'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageDescription,
                },
            ],
        };
    },
    computed: {
        pageDescription() {
            if (this.$store.getters.isCountryFinland) {
                return this.$t('pages.about.seo_page_desc_fi');
            }

            return this.$t('pages.about.seo_page_description', {
                siteName: this.$config.siteName,
                siteCountry: this.$t(`localization.countries.${this.$store.getters.siteCountryCodeWithFallback}`),
            });
        },
    },
    nuxtI18n: {
        paths: {
            se: '/om-oss',
            'fi-sv': '/om-oss',
            fi: '/tietoa-meista',
            en: '/about-us',
            de: '/ueber-uns',
            at: '/ueber-uns',
            no: '/om-oss',
            dk: '/om-os',
            ch: '/ueber-uns',
            fr: '/a-propos',
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.section {
    &__content {
        max-width: 680px;
    }
}

.section-image {
    &__image {
        border-radius: 20px;
    }

    @include lg {
        margin-left: 20px;
        margin-right: 20px;
    }
}

.about {
    &__header {
        @extend %heading-2;
        text-align: center;
        margin-bottom: 10px;
    }

    .team {
        max-width: 1040px;
        margin: 100px auto 0;
    }

    .persons {
        display: grid;
        grid-column-gap: 8px;
        grid-row-gap: 30px;
        grid-template-columns: repeat(1, 1fr);

        @include sm {
            grid-template-columns: repeat(2, 1fr);
        }

        @include lg {
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 30px;
        }
    }

    .person {
        &__image {
            width: 200px;
            height: 200px;
            object-fit: cover;
            border-radius: $default-border-radius;
        }
        &__name {
            margin: 5px auto;
            font-weight: 600;
        }
        &__title {
            margin-bottom: 20px;
            color: $secondary-text-color;
        }
    }
}
</style>
